export default function <T>(key: InjectionKey<T>): T {
    const value = inject(key)
    if (value == null) throw new Error(`Could not find required inject: ${String(key)}`)

    return value
}